<template>
    <div class="flex justify-between">
        <div class="mt2">
            <div class="formLabel">{{location.address}}</div>
            <div class="bodyCopy">{{location.city}}, {{location.province}} {{location.postal_code}}</div>
        </div>
        <!-- <img class="tr grow pointer" src="@/assets/img/icon_get_directions.svg"/> -->
    </div>
</template>

<script>
export default {
    props: {
        location: {
            type: Object,
            required: true
        }
    }
};
</script>
